<!--
 * @Author: huangyh
 * @Date: 2021-03-12 14:38:25
 * @LastEditors: huangyh
 * @LastEditTime: 2021-04-01 16:18:32
-->
<template>
  <div class="smy__card-full-box page-org" ref="infoBox">
    <Card class="smy__card-full" :bordered="false">
      <p slot="title" ref="infoTitle">问卷调查</p>
      <div class="options" ref="options">
        <Button type="ghost" icon="ios-undo" @click="back">返回</Button>
        <Button type="primary" @click="submit" :loading="submitLoading">保存</Button>
      </div>
      <div class="questPanel" :style="{'height':questPanelHeight + 'px'}">
        <div class="controlArea">
          <div class="control" v-for="item in controlList" draggable @dragstart="startDrag($event,item.type)" :key="item.type">{{item.label}}</div>
        </div>
        <div class="questionArea" @drop="drop" @dragover="allowDrop($event)">
          <div class="titleEditer">
            <h2>{{questionForm.theme}}</h2>
            <TextEditor :editorHeight="150" :defalutContent="questionForm.title" @on-change="questionForm.title = $event" />
          </div>
          <transition-group name="flip-list" tag="div">
            <div class="questionItem" v-for="(question,index) in quesList" :key="question.index">
              <div class="questionIndex" v-if="question.info.type != 6">{{index + 1}}</div>
              <div class="questionContent">
                <CustomControl :type="question.info.type" v-model="question.info" />
              </div>
              <div class="questionOpea">
                <div class="requireOpea inCenter" v-if="question.info.type != 5 && question.info.type != 6 && question.info.type != 7">
                  <span>此题必答</span>
                  <Switch v-model="question.info.isRequired" :true-value="1" :false-value="0" @on-change="syncChilrenState($event,question.info)"></Switch>
                </div>
                <div class="indexOpea inCenter">
                  <Icon type="arrow-up-c" class="iconSty" @click.native="sortUp(index)"></Icon>
                  <Icon type="arrow-down-c" class="iconSty" @click.native="sortDown(index)"></Icon>
                </div>
                <div class="delOpea inCenter">
                  <Icon type="trash-a iconSty" @click.native="delItem(index)"></Icon>
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </Card>
  </div>
</template>
<script>
import CustomControl from './CustomControl'
import TextEditor from '@/components/TextEditor.vue'
export default {
  components: {
    CustomControl,
    TextEditor,
  },
  data() {
    return {
      questPanelHeight: 0,
      switch1: false,
      controlList: [
        {
          label: '单选题',
          type: 1,
        },
        {
          label: '多选题',
          type: 2,
        },
        {
          label: '填空题',
          type: 3,
        },
        {
          label: '下拉',
          type: 4,
        },
        {
          label: '标题',
          type: 5,
        },
        {
          label: '分割线',
          type: 6,
        },
        {
          label: '说明文本',
          type: 7,
        },
        {
          label: '评分',
          type: 8,
        },
        {
          label: '横向填空',
          type: 9,
        },
        {
          label: '联系人',
          type: 10,
        },
      ],
      quesList: [],
      surveyId: '',
      nodeTmplId: '',
      questionForm: {
        title: '',
        theme: '',
      },
      submitLoading: false,
    }
  },
  mounted() {
    this.questPanelHeight =
      this.$refs.infoBox.clientHeight -
      this.$refs.infoTitle.clientHeight -
      this.$refs.options.clientHeight -
      91
    if (this.$route.query.surveyId) {
      this.nodeTmplId = this.$route.query.nodeTmplId
      this.surveyId = this.$route.query.surveyId
    }
    this.getQuestionDetail()
  },
  methods: {
    back() {
      this.$router.back()
    },
    getQuestionDetail() {
      this.$http
        .get('/survey/get/setting', {
          params: {
            surveyId: this.surveyId,
            nodeTmplId: this.nodeTmplId,
          },
        })
        .then((res) => {
          for (let item of res.data.nodeList) {
            let temp = []
            for (let fvsItem of item.fvs) {
              let fvsObj = {
                fvType: fvsItem.type,
                id: fvsItem.id,
              }
              if (item.type === 9) {
                fvsObj['orderNum'] = fvsItem.order_num
                fvsObj['isRequired'] = fvsItem.is_required
                fvsObj['fvName'] = ''
                fvsObj['fvRange'] = fvsItem.filed_range
              } else if (item.type === 10) {
                fvsObj['orderNum'] = fvsItem.order_num
                fvsObj['isRequired'] = fvsItem.is_required
                fvsObj['fvName'] = fvsItem.name
              } else {
                fvsObj['fvValue'] = fvsItem.value
              }
              temp.push(fvsObj)
            }
            console.log(temp)
            this.quesList.push({
              index: this.quesList.length + 1,
              info: {
                id: item.id,
                nodeId: item.nodeId,
                type: item.type,
                isRequired: item.is_required,
                name: item.name,
                orderNum: item.order_num,
                fvs: temp,
                content: item.content || '',
                ctrlId: item.ctrl_id,
              },
            })
          }
          this.questionForm.title = res.data.title
          this.questionForm.theme = res.data.theme
        })
    },
    // 托拽
    startDrag($event, type) {
      $event.dataTransfer.setData('type', type)
    },
    allowDrop($event) {
      $event.preventDefault()
    },
    drop($event) {
      let length = this.quesList.length
      let addObj = {
        index: length + 1,
        info: {
          nodeId: -1,
          type: 1,
          isRequired: 0,
          name: '单选',
          orderNum: length + 1,
          fvs: [],
        },
      }
      switch (Number($event.dataTransfer.getData('type'))) {
        case 1:
          addObj['info']['type'] = 1
          addObj['info']['name'] = '单选'
          break
        case 2:
          addObj['info']['type'] = 2
          addObj['info']['name'] = '多选'
          break
        case 3:
          addObj['info']['type'] = 3
          addObj['info']['name'] = '填空'
          break
        case 4:
          addObj['info']['type'] = 4
          addObj['info']['name'] = '下拉'
          break
        case 5:
          addObj['info']['type'] = 5
          addObj['info']['name'] = '标题'
          break
        case 6:
          addObj['info']['type'] = 6
          addObj['info']['name'] = '分割线'
          break
        case 7:
          addObj['info']['type'] = 7
          addObj['info']['name'] = '说明文本'
          break
        case 8:
          addObj['info']['type'] = 8
          addObj['info']['name'] = '评分'
          break
        case 9:
          addObj['info']['type'] = 9
          addObj['info']['ctrlId'] = -1
          addObj['info']['name'] = `横向填空`
          addObj['info']['content'] = `姓名________年龄____岁
联系方式___________`
          break
        case 10:
          addObj['info']['type'] = 10
          addObj['info']['name'] = '联系人'
          break
      }
      this.quesList.push(addObj)
    },
    sortUp(index) {
      if (index === 0) return
      let index2 = index - 1
      this.quesList[index2]['info']['orderNum'] = index + 1
      this.quesList[index]['info']['orderNum'] = index2 + 1
      this.quesList.splice(
        index2,
        1,
        ...this.quesList.splice(index, 1, this.quesList[index2])
      )
    },
    sortDown(index) {
      if (index === this.quesList.length - 1) return
      let index2 = index + 1
      this.quesList[index2]['info']['orderNum'] = index + 1
      this.quesList[index]['info']['orderNum'] = index2 + 1
      this.quesList.splice(
        index2,
        1,
        ...this.quesList.splice(index, 1, this.quesList[index2])
      )
    },
    delItem(index) {
      this.quesList.splice(index, 1)
    },
    // 同步必选状态
    syncChilrenState(state, info) {
      if (info.type === 9 || info.type === 10) {
        for (let item of info.fvs) {
          item['isRequired'] = state
        }
      }
    },
    submit() {
      this.submitLoading = true
      let form = {
        surveyId: this.surveyId,
        nodeTmplId: this.nodeTmplId,
        title: this.questionForm.title,
        nodeList: [],
      }
      for (let item of this.quesList) {
        form.nodeList.push(item.info)
      }
      this.$http
        .post('/survey/save/setting', form)
        .then((res) => {
          if (res.success) {
            this.submitLoading = false
            this.$Message.success('保存成功')
            this.back()
          } else {
            this.submitLoading = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.submitLoading = false
        })
    },
  },
}
</script>
<style lang="less" scoped>
.options {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.inCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.questPanel {
  width: 100%;
  display: flex;
  justify-content: space-between;
  overflow: auto;
  & > div {
    min-height: 100%;
  }
  .controlArea {
    width: 20%;
    border-right: 1px solid #ccc;
    padding: 5px;
    padding-top: 10px;
    padding-right: 30px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-content: flex-start;
    .control {
      width: 48%;
      height: 60px;
      border: 1px dashed #d6d4d4;
      margin-bottom: 20px;
      text-align: center;
      line-height: 60px;
      cursor: move;
      user-select: none;
    }
  }
  .questionArea {
    width: 80%;
    padding: 30px;
    padding-top: 10px;
    overflow: auto;
    .questionItem {
      background-color: white;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.35);
      margin: 20px 0;
      display: flex;
      justify-content: space-between;
      padding: 15px;
      padding-left: 0;
      .questionIndex {
        min-width: 30px;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
      }
      .questionOpea {
        min-width: 200px;
        user-select: none;
        flex-shrink: 0;
        .requireOpea {
          margin-bottom: 20px;
          span {
            font-size: 16px;
            margin-right: 10px;
          }
        }
        .iconSty {
          margin-right: 20px;
          cursor: pointer;
        }
        .indexOpea {
          margin-bottom: 20px;
          font-size: 30px;
        }
        .delOpea {
          font-size: 30px;
        }
      }
      .questionContent {
        width: 100%;
      }
    }
  }
}
.flip-list-move {
  transition: transform 0.5s;
}
.titleEditer {
  width: 100%;
  h2 {
    text-align: center;
    padding: 12px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/questionnaire/questionnaireList/info.vue